import { FETCH_AVAILABILITY } from "../actions/Availability";

export const initialState = {
  list: []
}

const availabilityReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_AVAILABILITY:
      return {
        ...state,
        list: action.payload
      };
    default:
      return state;
  }
}

export default availabilityReducer;